import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('userRole', data.role);
        localStorage.setItem('userName', data.name);
        localStorage.setItem('userId', data.id);
        if (onLogin) onLogin(data);
        if (data.role === 'customer') navigate('/customer/dashboard');
        else if (data.role === 'driver') navigate('/driver/dashboard');
        else if (data.role === 'admin') navigate('/admin');
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden' }}>
      {/* Animated Aurora Background */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(-45deg, #5227FF, #7cff67, #5227FF, #FF6B6B)',
        backgroundSize: '400% 400%',
        animation: 'auroraFlow 15s ease infinite',
        zIndex: 0
      }} />

      {/* Login Card */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '360px',
        padding: '40px',
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        borderRadius: '20px',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255,255,255,0.3)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        textAlign: 'center',
        zIndex: 1
      }}>
        <div style={{ marginBottom: '30px' }}>
          <h1 style={{ color: '#eab308', fontSize: '28px', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}></h1>
          <h2 style={{ color: '#eab308', fontSize: '28px', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}></h2>
          <p style={{ color: '#f0f0f0', textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', textAlign: 'left', fontWeight: '500' }}>EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="customer@example.com"
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid rgba(255,255,255,0.5)',
                backgroundColor: 'rgba(255,255,255,0.15)',
                color: 'white',
                fontSize: '14px',
                backdropFilter: 'blur(4px)',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#f9f9f9', fontSize: '12px', display: 'block', marginBottom: '5px', textAlign: 'left', fontWeight: '500' }}>PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid rgba(255,255,255,0.5)',
                backgroundColor: 'rgba(255,255,255,0.15)',
                color: 'white',
                fontSize: '14px',
                backdropFilter: 'blur(4px)',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          {error && (
            <div style={{ backgroundColor: 'rgba(220,38,38,0.3)', color: '#ffcccc', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#eab308',
              color: 'black',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'opacity 0.2s'
            }}
          >
            {loading ? 'LOGGING IN...' : 'SIGN IN'}
          </button>

          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <span
              onClick={() => navigate('/forgot-password')}
              style={{ color: '#eab308', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px' }}
            >
              Forgot Password?
            </span>
          </div>
        </form>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ color: '#f0f0f0', fontSize: '14px' }}>
            Don't have an account?{' '}
            <span onClick={() => navigate('/register')} style={{ color: '#eab308', cursor: 'pointer', textDecoration: 'underline' }}>
              Register
            </span>
          </p>
        </div>

        {/* ============ APP OPTIONS ============ */}
        <div style={{
          marginTop: '24px',
          paddingTop: '20px',
          borderTop: '1px solid rgba(255,255,255,0.2)'
        }}>
          <p style={{
            color: '#f0f0f0',
            fontSize: '11px',
            letterSpacing: '2px',
            marginBottom: '14px',
            opacity: 0.75
          }}>
            OUR APPS
          </p>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <a
              href="/login"
              style={{
                flex: 1,
                padding: '14px 8px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(234,179,8,0.5)',
                borderRadius: '12px',
                color: '#eab308',
                textDecoration: 'none',
                fontSize: '12px',
                fontWeight: 600,
                textAlign: 'center'
              }}
            >
              <div style={{ fontSize: '22px', marginBottom: '6px' }}>🚚</div>
              Vantrailer
            </a>

            <a
              href="/cookie/"
              style={{
                flex: 1,
                padding: '14px 8px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(249,115,22,0.5)',
                borderRadius: '12px',
                color: '#f97316',
                textDecoration: 'none',
                fontSize: '12px',
                fontWeight: 600,
                textAlign: 'center'
              }}
            >
              <div style={{ fontSize: '22px', marginBottom: '6px' }}>🍪</div>
              Cookie Delivery
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes auroraFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
};

export default Login;
